/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Template_Position_HInputs */



/**
* | output |
* | --- |
* | "H:" |
*
* @param {Event_Template_Position_HInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_template_position_h = /** @type {((inputs?: Event_Template_Position_HInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Template_Position_HInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("H:")
	if (locale === "de") return /** @type {LocalizedString} */ ("H:")
	if (locale === "it") return /** @type {LocalizedString} */ ("H:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЧАС:")
	if (locale === "es") return /** @type {LocalizedString} */ ("H:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("H：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("H:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एच:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("H:")
	return /** @type {LocalizedString} */ ("H:")
});